export const NO_PARENT_FIELD_ENTITY = 'interaction';
export const CONTACTS_FIELD_ENTITY = 'contacts';

export const GENERIC_COVER_SHEET_ERROR =
  'Sorry, the last change was not saved. Please try refreshing the page.';
